var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomationlineright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 124,
    viewBox: "0 0 326 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326 0.5H140.993C132.136 0.5 124.334 6.32466 121.817 14.8159L94.733 106.184C92.2159 114.675 84.4142 120.5 75.5577 120.5H1",
    stroke: "url(#paint0_linear_568_3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 120.5,
    r: 3,
    fill: "url(#paint1_linear_568_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_568_3",
    x1: 326,
    y1: 0.5,
    x2: 248.016,
    y2: 211.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_568_3",
    x1: 0,
    y1: 117.5,
    x2: 6.22193,
    y2: 117.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationlineright);
export default __webpack_public_path__ + "static/media/automationlineright.20d608c649bf96cd82c6cc28f88a7a5d.svg";
export { ForwardRef as ReactComponent };